import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

class FirebaseService {
  app;
  env: string;

  constructor() {
    this.app = initializeApp(firebaseConfig);
    this.env = process.env.REACT_APP_ENV ?? "dev";
  }

  get auth() {
    return getAuth(this.app);
  }

  get db() {
    return getFirestore(this.app);
  }

  get storage() {
    return getStorage(this.app);
  }
}

export default new FirebaseService();
